<script lang="ts" setup>
import SpecialistTitle from '~/components/specialist/SpecialistTitle.vue'

defineProps<{
  title: string
}>()
</script>

<template>
  <SpecialistTitle class="mb-3 mt-5 !text-[24px] md:mb-8 md:mt-0 md:!text-[40px]" :title="title" />
</template>
